import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';

import PageTitle from '../../components/stateless/PageTitle';
import Heading from '../../components/stateless/Heading';
import IconCard from '../../components/stateless/IconCard';
import Description from '../../components/stateless/Description';
import Button from '../../components/statefull/Button';

import { getData, postDataFormData } from '../../helpers/postData';

import './index.scss';
import SkeletonLoader from '../../components/stateless/Skeleton';
import { Skeleton } from '@mui/material';
import { removeTime } from '../../helpers';

function ProductsBlog () {
  const [newsList, setNewsList] = useState([]);
  const [topNews, setTopNews] = useState([]);
  const markup = (str) => ({__html: str});

  const query = (skip, take, slug) => `/rss-news?order=desc&offset=${skip}${slug?.length ? `&slugs[]=${slug}` : ''}&limit=${take}`;

  function structureNewsData(arr, name, slug, data) {
    return {
      name, 
      slug,
      arr: data.changelog,
      count: data.count,
    };
  }

  useEffect(async() => {
    const topNewsData = await getData(query(0, 3));
    const newsData = await getData(query(0, 4, 'companyNews'));
    const blogData = await getData(query(0, 4, 'blog'));
    const educationalData = await getData(query(0, 4, 'educational'));

    setTopNews(topNewsData.data.changelog);
    setNewsList([
      structureNewsData('news', 'News', 'companyNews', newsData.data),
      structureNewsData('news', 'Blog', 'blog', blogData.data),
      structureNewsData('news', 'Educational', 'educational', educationalData.data),
    ]);
  }, [getData]);

  return  (
    <>
    <div className="news-content-wrap">
      <div className="news-content-layout">
        <div className="top-news">
          <p className="news-content-title">Latest News</p>
          <div className="main-container">
              {
                  topNews.length ? topNews.map(news =>
                      <Link to={'/products-blog/' + news.categorySlug + '/' + news.id} key={news.id}>
                        <div className="image-block">
                          <div className="image-block-inner" style={{backgroundImage: `url("${news.fileUrl}")`}}>
                        </div>
                        </div>
                        <div className="news-info">
                          <div className="news-title">{news.title}</div>
                          <p className="news-content" dangerouslySetInnerHTML={markup(news.preview)}></p>
                          <div className="news-views-date">
                            <span className="date">{removeTime(news.updatedAt)}</span>
                          </div>
                        </div>
                      </Link>
                  ) : <>
                  <Skeleton variant="rectangular" width="100%" height={200}/>
                  <Skeleton variant="rectangular" width="100%" height={200}/>
                  <Skeleton variant="rectangular" width="100%" height={200}/>
                  <Skeleton variant="rectangular" width="100%" height={200}/>
                  </>
              }
          </div>
        </div>
        <div className="all-news">
            {
                newsList.length ? newsList.map(group =>
                    group.count
                        ? <>
                    <div className="group-heading">
                      <p className="news-content-title">{group.name}</p>
                        {
                            group.count > 4 &&
                            <div className="btn-wrapper">
                              <Button link={'/products-blog/' + group.slug} stroked={true} content="See All" />
                            </div>
                        }
                    </div>
                    <div className="news-grid-layout">
                        {
                            group.arr.map(news =>
                                <Link to={'/products-blog/' + news.categorySlug + '/' + news.id} key={news.id} className="single-news">
                                  <div className="image-block">
                                    <div className="image-block-inner" style={{ backgroundImage: `url("${news.fileUrl}")` }}/>
                                  </div>
                                  <div className="news-info">
                                    <div className="news-title">{news.title}</div>
                                    <p className="news-content" dangerouslySetInnerHTML={markup(news.preview)}/>
                                  </div>
                                  <div className="news-views-date">
                                    <span className="date">{removeTime(news.updatedAt)}</span>
                                  </div>
                                </Link>
                            )
                        }
                    </div>
                    </>
                        : ''
                ) : <div className="grid-4">
                  <Skeleton variant="rectangular" width="100%" height={200}/>
                  <Skeleton variant="rectangular" width="100%" height={200}/>
                  <Skeleton variant="rectangular" width="100%" height={200}/>
                  <Skeleton variant="rectangular" width="100%" height={200}/>
                </div>
            }
        </div>
      </div>
    </div>

    </>
  );
}

export default ProductsBlog;
